import React from 'react'
import Stepper from '../../common/Stepper'

interface ISectionHeaderAndProgressProps {
  currentStep: number
  steps: number
  title: string
}

const SectionHeaderAndProgress = React.memo(({ currentStep, steps, title }: ISectionHeaderAndProgressProps) => {
  return (
    <div className='flex items-center justify-between'>
      <h3 className='font-black1 my0 text-lg weight-500'>{title}</h3>
      <Stepper currentStep={currentStep} steps={steps} />
    </div>
  )
})

export default SectionHeaderAndProgress



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/SectionHeaderAndProgress.tsx